import { autoInjectable } from 'tsyringe';
import { EpStore } from '../services/store/ep-store';
import { ofType } from 'deox';
import { AnalyticsActions } from '../actions';
import { tap } from 'rxjs/operators';
import { BpMetricsClickPlacementProperties } from '@ads-ep/api-metrics';
import { cleanMetricsContent } from '../modules/analytics/util/ep-metrics-event.util';
import { Analytics } from '../modules/analytics/analytics';
import { CommonEffect } from './common-effect';
import { merge } from 'rxjs';

@autoInjectable()
export class AnalyticsEffects implements CommonEffect {

  /*
   * Analytics Actions
   * */
  trackPlacementClickEvent$ = this.store.actions$.pipe(
    ofType(AnalyticsActions.trackPlacementClickEvent),
    tap(action => {
      const actionTarget = action.payload.domEl.dataset.actionTarget;

      const clickEventData: BpMetricsClickPlacementProperties = {
        eventProperties: {
          placement: this.analytics.getPlacementTrackingObj(action.payload.placementConfig),
          placementContent: cleanMetricsContent(action.payload.placementConfig.content),
          metadata: action.payload.placementMetaData,
          actionTarget,
        },
        userProperties: {},
      };
      this.analytics.v1ClickPlacementPost(clickEventData);
    }),
  );

  /*
  * Track the view placement event
  * */
  trackViewPlacementEvent$ = this.store.actions$.pipe(
    ofType(AnalyticsActions.trackViewPlacementEvent),
    tap(action => {
      this.analytics.v1ViewPlacementPost(action.payload.eventData);
    }),
  );

  /*
    * Track the view overlay event
    * */
  trackViewOverlayEvent$ = this.store.actions$.pipe(
    ofType(AnalyticsActions.trackViewOverlayEvent),
    tap(action => {
      this.analytics.v1ViewOverlayPost(action.payload.eventData);
    }),
  );

  /*
  * Track click overlay event
  * */
  trackClickOverlayEvent$ = this.store.actions$.pipe(
    ofType(AnalyticsActions.trackClickOverlayEvent),
    tap(action => this.analytics.v1ClickOverlayPost(action.payload.eventData)),
  );

  constructor(private store?: EpStore,
              private analytics?: Analytics) {
  }

  bindSideEffects() {
    return merge(
      this.trackPlacementClickEvent$,
      this.trackViewPlacementEvent$,
      this.trackViewOverlayEvent$,
      this.trackClickOverlayEvent$,
    ).subscribe()
  }
}
